/* eslint-disable jsx-a11y/alt-text */

import React, { useEffect, useMemo, useState, useRef } from "react";
import classnames from "classnames";
import {
    Card,
    Col,
    Container,
    Input,
    Nav,
    NavItem,
    NavLink,
    Popover,
    PopoverBody,
    Row,
    TabContent,
    TabPane
} from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import BreadCrumb from "../../../../Components/Common/BreadCrumb"
import floder from "../../../../assets/images/folder3.png"

//redux
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { createMediaCenter, deleteFolder, deleteMedia, getfolder, getmedia, getmedia as getMediaApi, getVideo, mediaMove, updateFolder } from "live-slices/media-center/thunk";
// import { createMediaCenter, deleteFolder, deleteMedia, getfolder, getmedia, getmedia as getMediaApi, getMediaByFolderID, updateFolder } from "live-slices/media-center/thunk";


import UploadImageModal from "./components/UploadImageModal";
import DeleteModal from "Components/Common/DeleteModal";
import Removebackground from "./components/Removebackground";
import { deleteMediaByIds, getFolder, getMediaVideo } from "helpers/backend_helper";
import ExportCSVModal from "Components/Common/ExportCSVModal";
import MediaCenterUploadModal from "./components/MediaCenterUploadModal";
import CreateFolder from "./components/CreateFolder";
import { createFolder as CreateFolderApi, getfolder as getFolderApi } from "live-slices/media-center/thunk"
import MoveToFolderModal from "./components/MoveToFolderModal";
import MediaBreadCrumb from "./components/MediaBreadCrumb";
import { Link } from "react-router-dom";
import ImageDetailsModal from "./components/DetailMedia";
import { ImageEditorComponent } from "@syncfusion/ej2-react-image-editor";
import { registerLicense } from '@syncfusion/ej2-base';
import { FirebaseAuthBackend, getFirebaseBackend } from "helpers/firebase_helper";
import index from "pages/Email/EmailTemplates/BasicAction";
import VideoViewer from "Components/Common/VideoViewer";
const productStatuses = [
    { label: "Image", value: "all", countKey: "image", },
    { label: "Video", value: "active", countKey: "video", },
];

const MediaCenter = (props: any) => {
    document.title = "Media-Center | BuyPass";
    const [folderStack, setFolderStack] = useState<{ name: string, id: string }[]>([]);

    const [tabs, setTabs] = useState<any[]>(productStatuses);
    const [activeTab, setActiveTab] = useState<any>(productStatuses[0].value);
    const dispatch = useDispatch<any>();
    const [activeItems, setActiveItems] = useState<{ [key: string]: boolean }>({});
    const [keyword, setKeyword] = useState('');
    const [keywordVideos, setkeywordVideos] = useState('');
    const [isExportCSV, setIsExportCSV] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<number>(0);
    const [endDate, setEndDate] = useState<number>(0);
    // const [folderId, setFolderId] = useState('');
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>("https://firebasestorage.googleapis.com/v0/b/cnc-hospital-7f706.appspot.com/o/product%2F17349772213011730417744070__publicwebbg_1730417748023.jpg?alt=media&token=1da9ee57-22d2-4e11-b5d4-f9c354e7c95e");
    const [loading, setLoading] = useState(false);
    const firebaesHelper: FirebaseAuthBackend | null = getFirebaseBackend();
    const [selectedVideos, setSelectedVideos] = useState<string[]>([]);

    const [activePopover, setActivePopover] = useState<string | null>(null);
    const [folderDeleteId, setFolderDeleteId] = useState('');



    const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedDate = new Date(e.target.value);
        setStartDate(selectedDate.getTime()); // Convert date to timestamp
    };

    const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedDate = new Date(e.target.value);
        setEndDate(selectedDate.getTime()); // Convert date to timestamp
    };
    registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF1cXmhNYVFpR2Nbek5yflVAal1VVAciSV9jS3tTdUVgWX1fcHZXR2JeUg/');




    const mediaData = createSelector(
        (state: any) => state.MediaCenter,
        (mediaList) => mediaList?.mediaList
    );
    const media = useSelector(mediaData) || [];


    const videoData = createSelector(
        (state: any) => state.MediaCenter,
        (videosList) => videosList?.videosList
    );
    const videos = useSelector(videoData) || [];


    const folderData = createSelector(
        (state: any) => state.MediaCenter,
        (folders) => folders?.folders
    );
    const folder = useSelector(folderData);



    const handleDownload = async (mediaUrl: any, mediaName: any) => {
        try {
            const response = await fetch(mediaUrl);
            const blob = await response.blob();
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = mediaName || 'untitled';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };



    useEffect(() => {
        dispatch(getMediaApi({ folderid: folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "", keyword, stardate: startDate, enddate: endDate }));
        dispatch(getFolderApi(folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "",))
        // if (folderStack.length>0) {
        // } else {
        //     dispatch(getFolderApi(""))
        //     dispatch(getMediaApi({ folderid: "", keyword, stardate: startDate, enddate: endDate }));
        // }
    }, [keyword, startDate, endDate, folderStack]);

    useEffect(() => {
        dispatch(getVideo({ page: 1, count: 10, keyword: keyword }));
    }, []);

    useEffect(() => {
    }, [media]);

    const handleClear = () => {
        const clearedKeyword = '';
        setStartDate(0);
        setEndDate(0);
        setKeyword(clearedKeyword);
        dispatch(getMediaApi({
            folderid: folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "",
            keyword: clearedKeyword,
            stardate: 0,
            enddate: 0
        }));
    };

    const handleClearVideosSearch = () => {
        setkeywordVideos('');
        dispatch(getVideo({ page: 1, count: 20, keyword: "", }));
    };


    const [uploadImageModal, setUploadImageModal] = useState<boolean>(false);
    const [activeArrowTab, setactiveArrowTab] = useState(() => {
        return Number(localStorage.getItem("activeArrowTab")) || 4;
    });
    const [passedarrowSteps, setPassedarrowSteps] = useState([4]);
    const isAnyActive = Object.values(activeItems).some((isActive) => isActive);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [DetailModal, setDetailModal] = useState<boolean>(false);
    const [deleteFolderModal, setDeleteFolderModal] = useState<boolean>(false);
    const [removebackgroundModal, setRemovebackgroundModal] = useState<boolean>(false);
    const [createFolder, setCreateFolder] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [selectedFolderName, setSelectedFolderName] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    // const [moveToFolderModal, setMoveToFolderModal] = useState<boolean>(false);
    // const [moveToFolderModal, setMoveToFolderModal] = useState<{ show: boolean, mediaIds: string[] }>();
    // console.log(activeItems, moveToFolderModal, "djfdk")
    // const [folderStack, setFolderStack] = useState<string[]>([]); 
    // const [folderId, setFolderId] = useState<string | null>(null); // Current folder id

    const [parentId, setParentId] = useState(null); // Assuming you have a parentId too, adjust as needed.
    const [folderName, setFolderName] = useState('');
    const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
    const [selectedEditMedia, setSelectedEditMedia] = useState<string | null>(null);
    const [selectedImageForDetails, setselectedImageForDetails] = useState(null);
    const [selectedMediaId, setselectedMediaId] = useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true); // Initial state as false means the button is enabled
    const [isMultiple, setIsMultiple] = useState(false);


    const handleExportUrls = () => {
        const selectedItems = media
            .filter((item: any) => activeItems[item._id])
            .map((item: any) => ({
                url: item.url || 'https://via.placeholder.com/120',
                name: item.metaData?.name || 'Untitled',
            }));

        if (selectedItems.length > 0) {
            const csvContent = [
                ['URL', 'Name'],
                ...selectedItems.map((item: any) => [item.url, item?.name]),
            ]
                .map((row) => row.join(','))
                .join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'selected_urls.csv';
            link.click();
        } else {
            alert('No media items selected.');
        }
    };




    const handlePopoverToggle = (id: string | null) => {
        setActivePopover(id);
    };


    const handleDeleteFolderConfirm = async () => {
        await deleteFunction(folderDeleteId)
    }

    const deleteFunction = async (id: string) => {
        await dispatch(deleteFolder({ id: id })).then(() =>
            dispatch(getFolderApi(folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "")),
            toast.success("Folder Delete Successfully", { autoClose: 1000 }),
            setDeleteFolderModal(false),
            // window.location.reload()
        );
    }

    const handleDeleteConfirm = async () => {
        const idsToDelete = selectedItemId
            ? selectedItemId
            : Object.keys(activeItems).filter((id: any) => activeItems[id]).join(',');

        if (idsToDelete) {
            await dispatch(deleteMedia({ ids: idsToDelete })).then(() => {
                toast.success("Media deleted successfully");
                dispatch(getMediaApi({ folderid: folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "", keyword, stardate: startDate, enddate: endDate }));
                setDeleteModal(false);
                setActiveItems({});
                setSelectedItemId(null); // Reset single-item delete state'
                window.location.reload()
            });
        }
    };


    const handleMediaIds = async () => {
        if (activeItems) {
            const selectedIds = Object.keys(activeItems)
                .filter((id: any) => activeItems[id])
                .join(',');
        }
    };

    const handleCheckboxChange = (_id: string) => {
        setActiveItems((prev: any) => {
            // if (isMultiple) {
            return {
                ...prev,
                [_id]: !prev[_id],
            };
            // }
            // else {
            //     const newActiveItems = { [_id]: !prev[_id] };
            //     return newActiveItems;
            // }
        });
    };

    const handleSelectAll = () => {
        const allSelected = media.every((item: any) => activeItems[item._id]);
        const newActiveItems = media.reduce((acc: any, item: any) => {
            acc[item._id] = !allSelected;
            return acc;
        }, {} as { [key: string]: boolean });

        setActiveItems(newActiveItems);
    };




    function toggleArrowTab(tab: any) {
        if (activeArrowTab !== tab) {
            var modifiedSteps = [...passedarrowSteps, tab];

            if (tab >= 4 && tab <= 8) {
                setactiveArrowTab(tab);
                setPassedarrowSteps(modifiedSteps);
                localStorage.setItem("activeArrowTab", tab.toString());
            }
        }
    }



    const handleCopy = (url: string) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                // alert('URL copied to clipboard!');
                toast.success("Copy Success", { autoClose: 500 })
            })
            .catch((err) => {
                console.error('Failed to copy: ', err);
            });
    };

    // const handleDelete = (ids:any) => {
    //           dispatch(deleteMedia({ ids, navigate }));
    //           setDeleteModal(false);
    // };

    const handleSearchChange = (event: any) => {
        setKeyword(event.target.value);
    };
    const handleSearchChangeVideo = (event: any) => {
        setkeywordVideos(event.target.value);
    };

    // const getSelectedVendorsData = (selectedIds: string[], media: any[]) => {
    //     return media.filter((item: any) => selectedIds.includes(item._id));
    // };


    // const prepareCSVData = () => {
    //     const selectedElements = document.querySelectorAll(".productCheckBox:checked");
    //     const selectedIds: string[] = Array.from(selectedElements).map(
    //         (element: any) => element.value
    //     );

    //     console.log("Selected IDs:", selectedIds);

    //     const selectedMedia = getSelectedVendorsData(selectedIds, media);

    //     console.log("Matched Media:", selectedMedia);

    //     return selectedMedia.map((item: any, index: number) => ({
    //         "#": index + 1,
    //         "Media URL": item.media?.url || "-",
    //     }));
    // };

    const functionMerge = async (parentIdEdit: string, message: string) => {
        setTimeout(() => {
            if (parentIdEdit) {
                dispatch(getmedia({ folderid: parentIdEdit, keyword, stardate: 0, enddate: 0 }));
                dispatch(getfolder(parentIdEdit));
            } else {
                setFolderStack([]);
                dispatch(getmedia({ folderid: "", keyword, stardate: 0, enddate: 0 }));
                dispatch(getfolder(""));
            }
            toast.success(message, { autoClose: 1000 });
            setCreateFolder(false);
        }, 1000);
    }

    const handleSubmit = async ({ folderName, folderIdSelected, _id }: { folderName: string; folderIdSelected?: string; _id?: any }) => {
        const parentIdEdit = folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "";

        try {
            if (isEdit) {
                const result = await dispatch(updateFolder({ _id: folderIdSelected ?? "", folderName }));
                if (result?.error && result.error.message === 'Rejected') {
                    setCreateFolder(true);

                } else {
                    await functionMerge(parentIdEdit, "Folder Updated Successfully!")
                }
            } else {
                const result = await dispatch(CreateFolderApi({ folderName, parentId: parentIdEdit }));
                if (result?.error && result.error.message === 'Rejected') {
                    setCreateFolder(true);
                } else {
                    await functionMerge(parentIdEdit, "Folder Created Successfully!")

                }
            }
        } catch (error) {
            console.error("Error during folder submission:", error);
            toast.error("Unexpected error occurred");
        }

        // Close modal only if successful
    };



    const clearSelected = async () => {
        setActiveItems({});

    }

    const handleFolderClick = async (folderName: string, folderId: string) => {
        setIsLoading(true);
        try {
            setActiveItems({});
            setFolderStack((prevStack) => [...prevStack, { name: folderName, id: folderId }]);
            setSelectedFolderName(folderName);
            // setFolderId(folderId);
            await dispatch(getmedia({ folderid: folderId, keyword, stardate: 0, enddate: 0 }));

            await dispatch(getFolderApi(folderId));
        } catch (error) {
            console.error("Error fetching folder data", error);
        } finally {
            setIsLoading(false);
        }
    };

    const exportMediaURLs = async (folderId: string) => {
        try {
            const mediaResponse = await dispatch(getmedia({ folderid: folderId, keyword, stardate: 0, enddate: 0 }));

            const mediaItems = mediaResponse?.payload?.data || [];
            if (mediaItems.length > 0) {
                const csvRows: string[] = [];
                csvRows.push('Name,URL');
                mediaItems.forEach((mediaItem: any) => {
                    if (mediaItem.url) {
                        const row = `${mediaItem?.metaData?.name || 'Unnamed File'},${mediaItem.url}`;
                        csvRows.push(row);
                    }
                });
                const csvContent = csvRows.join("\n");
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "media-urls.csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                dispatch(getmedia({ folderid: folderId, keyword, stardate: 0, enddate: 0 }));
            } else {
                toast.error("This folder was empty!");
                dispatch(getmedia({ folderid: folderId, keyword, stardate: 0, enddate: 0 }));
                console.error("No media items found in the media response");
            }
        } catch (error) {
            console.error("Error exporting media URLs", error);
        }
    };

    const handleBackClick = async (index: number, id: string = "", name: string = "Image") => {
        if (isLoading) return;

        setIsLoading(true);

        try {
            const selectedFolder = folderStack[index];
            setActivePopover(null)
            if (id === "") {
                selectedFolder.id = "";
                selectedFolder.name = name;
            }
            await dispatch(getFolderApi(selectedFolder.id));
            await dispatch(getmedia({ folderid: selectedFolder.id, keyword, stardate: 0, enddate: 0 }));

            setFolderStack((prevStack) => prevStack.slice(0, index + 1));

        } catch (error) {
            console.error("Error fetching folder data", error);
        } finally {
            setIsLoading(false);
        }
    };

    if (Array.isArray(media)) {
        const filteredMedia = media.filter(item => item.isDeleted === false);
    }

    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleMouseEnter = (folderId: string) => {
        setActivePopover(folderId); // Open popover on hover
    };

    const handleMouseLeave = () => {
        setActivePopover(null); // Close popover when mouse leaves
    };

    const handleEditClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsEditorOpen(true);
    };

    const imageDataToBase64 = (imageData: ImageData) => {
        const canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            console.error("Canvas context not found.");
            return null;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas.toDataURL('image/png'); // or 'image/jpeg'
    };

    const handleSave = async () => {
        if (!imageEditorRef.current || !imageEditorRef.current.element) {
            console.error("Editor instance not found.");
            return;
        }

        const editor = (imageEditorRef.current.element as any).ej2_instances[0];

        const editedImageData = editor.getImageData();
        if (!editedImageData) {
            console.warn("No edited image data available.");
            return;
        }

        const editedImageBase64 = imageDataToBase64(editedImageData);
        if (!editedImageBase64) {
            console.error("Failed to convert image data to Base64.");
            return;
        }

        const imageBlob = base64ToBlob(editedImageBase64, "image/png");

        setLoading(true);

        try {
            const res = await firebaesHelper?.uploadImage(imageBlob, "product/");
            if (res) {
                const targetMedia = media.find(
                    (item: any) => item.url === selectedImage
                );
                if (targetMedia) {
                    const updatedTargetMedia = {
                        ...targetMedia,
                        url: res,
                        modifiedOn: Date.now(),
                    };

                    await dispatch(createMediaCenter(updatedTargetMedia));
                    // await dispatch(getmedia({ keyword: "", stardate: 0, enddate: 0 }));
                    // await dispatch(getFolderApi(folderId)); 
                    dispatch(getmedia({ folderid: folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "", keyword: "", stardate: 0, enddate: 0 }));
                    dispatch(getfolder(folderStack.length > 0 ? folderStack[folderStack.length - 1].id : ""));
                    toast.success("Image updated successfully!");
                } else {
                    console.error("Target image not found.");
                }
            } else {
                console.error("Failed to upload image to Firebase.");
            }
        } catch (error) {
            console.error("Error while uploading image:", error);
        } finally {
            setLoading(false);
            setIsEditorOpen(false);
        }
    };

    function base64ToBlob(base64: string, mimeType: string) {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset++) {
            const byteArray = new Uint8Array(1);
            byteArray[0] = byteCharacters.charCodeAt(offset);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mimeType });
    }

    const handleImageClick = (imageUrl: any) => {
        setSelectedImage(imageUrl);
        setIsEditorOpen(true);
        setDetailModal(false)
    };

    const imageEditorRef = useRef<ImageEditorComponent | null>(null);

    useEffect(() => {
        if (imageEditorRef.current && selectedImage && isEditorOpen) {
            if (typeof imageEditorRef.current.open === 'function') {
                imageEditorRef.current.open(selectedImage);
            } else {
                console.error("The 'open' method does not exist on the imageEditorRef.");
            }
        } else if (!selectedImage) {
            console.log("Selected image is null or undefined.");
        }
    }, [selectedImage, isEditorOpen]);

    const handleEdit = (existingFolderName: any, existingParentId: any) => {
        setFolderName(existingFolderName); // Set the folderName to the current folder name you want to edit
        setParentId(existingParentId); // If needed, set the parentId as well
        setIsEdit(true);
        setCreateFolder(true); // Show the CreateFolder modal
    };

    const handleCreateNew = () => {
        setIsEdit(false);
        setCreateFolder(true);
    };

    const handleImageClickDetail = (item: any) => {
        setselectedImageForDetails(item);
        setselectedMediaId(item._id);
        setDetailModal(true);
    };

    const handleClickEdit = (mediaUrl: any) => {
        setSelectedEditMedia(mediaUrl);
        setDetailModal(true);
    };

    const handleSearch = () => {
        if (!startDate && !endDate && !keyword) {
            toast.error("Please enter at least one search criterion.");
            return;
        }
        dispatch(getMediaApi({ folderid: folderStack.length > 0 ? folderStack[folderStack.length - 1].id : "", keyword, stardate: startDate, enddate: endDate }));
    };

    const [moveToFolderModal, setMoveToFolderModal] = useState<boolean>(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (keywordVideos || keywordVideos === '') {
                dispatch(getVideo({ page: 1, count: 20, keyword: keywordVideos }));
            }
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [keywordVideos, dispatch]);




    const handleVideoSelect = (video: any) => {
        setSelectedVideos((prevSelected) => {
            if (prevSelected.includes(video)) {
                return prevSelected.filter((item: any) => item !== video);
            } else {
                return [...prevSelected, video];
            }
        });
    };

    const handleCopyToClipboard = (url: string) => {
        navigator.clipboard.writeText(url).then(
            () => {
                toast.success("Link copied!");
            },
            (err) => {
                console.error('Failed to copy URL: ', err);
            }
        );
    };


    const exportToCSV = () => {
        const headers = ['Created Date', 'Video Title', 'Video ID'];
        const rows = selectedVideos.map((id: any) => {
            const video = videos.find((video: any) => video._id === id);
            const updatedOnTimestamp = video?.createdOn ? new Date(video.createdOn) : null;
            const updatedOn = updatedOnTimestamp
                ? updatedOnTimestamp.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                })
                : 'Unknown Date';

            return [
                updatedOn,  // Formatted date
                video?.metaData?.name || 'Untitled',
                video?._id,
            ];
        });

        const csvContent = [
            headers.join(','),
            ...rows.map((row) => row.join(',')),
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'selected_videos.csv');
        link.click();
    };


    const handleExportToCSV = () => {
        const imageData = media
            .filter((item: any) => item.type === 'image')
            .map((item: any) => ({
                url: item.url || 'https://via.placeholder.com/120',
                name: item.metaData?.name || 'Untitled',
            }));
        const csvHeader = ['URL', 'Name'];
        const csvRows = imageData.map((item: { url: string; name: string }) => [item.url, item.name]);
        let csvContent = 'data:text/csv;charset=utf-8,';
        csvContent += csvHeader.join(',') + '\n';
        csvRows.forEach((row: string[]) => {
            csvContent += row.join(',') + '\n';
        });
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'images.csv');
        link.click();
    };

    const handleMoveToFolder = async ({ moveFolderId }: { moveFolderId: string }) => {
        const selectedMediaIds = Object.keys(activeItems).filter((id: any) => activeItems[id]);
        if (!moveFolderId || selectedMediaIds.length === 0) {
            toast.error("Please select a folder and media items.");
            return;
        }
        const payload = {
            folderId: moveFolderId,
            mediaIds: selectedMediaIds,
        };
        try {
            const result = await dispatch(mediaMove(payload));
            setMoveToFolderModal(false)
            setActiveItems({})
            if (folderStack.length > 0 && folderStack[folderStack.length - 1].id) {
                dispatch(getMediaApi({ folderid: folderStack[folderStack.length - 1].id, keyword, stardate: startDate, enddate: endDate }));
            } else {
                dispatch(getMediaApi({ folderid: "", keyword, stardate: startDate, enddate: endDate }));
            }
            // setFolderStack([])
            // setFolderId("")
            toast.success("Media moved successfully!");
        } catch (error) {
            console.error("Error moving media:", error);
            toast.error("Failed to move media. Please try again.");
        }
    };

    const [currentImage, setCurrentImage] = useState("");
    const [isViewerOpen, setViewerOpen] = useState(false);

    const openViewer = (videoUrl: string) => {
        setCurrentImage(videoUrl);
        setViewerOpen(true);
    };
    const closeViewer = () => {
        setViewerOpen(false);
    };


    return (
        <div className="page-content">
            <ToastContainer closeButton={false} limit={1} />
            <ExportCSVModal
                show={isExportCSV}
                onCloseClick={() => setIsExportCSV(false)}
            // data={prepareCSVData()}
            />
            <UploadImageModal
                key={uploadImageModal.toString()}
                show={uploadImageModal}
                onDeleteClick={() => setUploadImageModal(false)}
                onCloseClick={() => setUploadImageModal(false)}
                selectedFolderId={folderStack.length > 0 ? folderStack[folderStack.length - 1].id : ""}
            />
            <DeleteModal
                show={deleteModal}
                onDeleteClick={() => handleDeleteConfirm()}
                onCloseClick={() => setDeleteModal(false)}
            />
            <DeleteModal
                show={deleteFolderModal}
                onDeleteClick={() => handleDeleteFolderConfirm()}
                onCloseClick={() => setDeleteFolderModal(false)}
            />
            <ImageDetailsModal
                show={DetailModal}
                onDetailClick={() => setDetailModal(false)}
                onCloseClick={() => setDetailModal(false)}
                onDeleteClick={() => {
                    setDeleteModal(true);
                    setSelectedItemId(selectedMediaId);
                }}
                onClickEdit={() => handleImageClick(selectedImage)}
                folderName={folderName}
                selectedImage={selectedImageForDetails}
            />
            <MoveToFolderModal
                show={moveToFolderModal}
                submitButton={(moveFolderId: any) => handleMoveToFolder({ moveFolderId })}
                onCloseClick={() => setMoveToFolderModal(false)}
                selectedFolderId={folderStack.length > 0 ? folderStack[folderStack.length - 1].id : ""}

            />
            <Removebackground
                show={removebackgroundModal}
                submitButton={() => setRemovebackgroundModal(false)}
                onCloseClick={() => setRemovebackgroundModal(false)}
            />


            {/* <CreateFolder */}
            {/* // addProduct media Upload  */}


            <CreateFolder
                show={createFolder}
                folderName={folderName}
                parentId={parentId}
                _id={folder?._id}
                submitButton={(folderName, folderIdSelected,) => handleSubmit({ folderName, folderIdSelected, })}
                onCloseClick={() => setCreateFolder(false)}
                isEdit={isEdit}
            />
            <Container fluid>

                <BreadCrumb title="Media Center" pageTitle="Products" pageTitleRoute="/manage-products" />

                <Row>
                    <Col xl={12} lg={12}>
                        <div>
                            <Card className="p-3">
                                <Row className="border-bottom mb-3 mx-2">
                                    <Col md={2} sm={12} className="p-0">
                                        <div className="step-arrow-nav ">
                                            <Nav className="nav-pills custom-nav nav-justified" role="tablist">
                                                <NavItem style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                                                    <NavLink
                                                        href="#"
                                                        id="steparrow-gen-info-tab"
                                                        data-testing-Id="imageTab_mediaCenter"
                                                        className={classnames({
                                                            active: activeArrowTab === 4,
                                                            done: activeArrowTab <= 6 && activeArrowTab > 3,
                                                        })}
                                                        onClick={() => {
                                                            toggleArrowTab(4);
                                                        }}
                                                        style={{
                                                            whiteSpace: "nowrap", // Prevents text from breaking into new lines
                                                            overflow: "hidden",   // Hides overflow text
                                                            textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            padding: "10px", // Adds some padding for spacing
                                                        }}
                                                    >
                                                        Image
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                                                    <NavLink
                                                        href="#"
                                                        id="steparrow-gen-info-tab"
                                                        data-testing-Id="videoTab_mediaCenter"
                                                        className={classnames({
                                                            active: activeArrowTab === 5,
                                                            done: activeArrowTab <= 6 && activeArrowTab > 4,
                                                        })}
                                                        onClick={() => {
                                                            toggleArrowTab(5);
                                                        }}
                                                        style={{
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        Video
                                                    </NavLink>
                                                </NavItem>

                                            </Nav>



                                        </div>
                                    </Col>
                                </Row>

                                <TabContent activeTab={activeArrowTab}>
                                    <TabPane id="steparrow-gen-info-tab" tabId={4}>
                                        <Row className="topButtonBar d-flex justify-content-between align-items-center  my-4">
                                            <Col lg={4} md={12} sm={12} className="">
                                                <button type="button" className="btn btn-secondary me-2" data-testing-Id="uploadImageButton_mediaCenter" onClick={() => setUploadImageModal(true)}>Upload Image</button>
                                                <button type="button" className="btn btn-outline-secondary" data-testing-Id="newFolderButton_mediaCenter" onClick={handleCreateNew}>Create New Folder</button>
                                            </Col>
                                            <Col lg={8} md={12} sm={12} >
                                                <Row className=" mobileRow">
                                                    <Col sm={12} lg={3} md={2}>
                                                    <div className="formContainer">
                                                            <label className="form-label" style={{color: "#a2b1c3", fontSize: "12px" ,position: "absolute", top: "-9px", zIndex: "10", left: "25px", background: "white", padding: "0px 5px"}} >Start Date</label>
                                                            <Input
                                                            style={{position: "relative", border: "2px solid #e2e7ea", borderRadius: "10px", height: "40px",color: "#010101 !important", fontSize: "14px",  }}
                                                                type="date"
                                                                placeholder="Start Date"
                                                                data-testing-Id="startDate_mediaCenter"
                                                                onChange={handleStartDateChange}
                                                                value={startDate ? new Date(startDate).toISOString().split('T')[0] : ''}
                                                            />

                                                    </div>
                                                    </Col>
                                                    <Col sm={12} lg={3} md={2}>
                                                        <div className="dateInput">
                                                        <label className="form-label" style={{color: "#a2b1c3", fontSize: "12px" ,position: "absolute", top: "-9px", zIndex: "10", left: "25px", background: "white", padding: "0px 5px"}} >End Date</label>
                                                            <Input
                                                                type="date"
                                                            style={{position: "relative", border: "2px solid #e2e7ea", borderRadius: "10px", height: "40px",color: "#010101 !important", fontSize: "14px",  }}
                                                                placeholder="End Date"
                                                                data-testing-Id="endDate_mediaCenter"
                                                                onChange={handleEndDateChange}
                                                                min={startDate ? new Date(startDate).toISOString().split('T')[0] : undefined}
                                                                value={endDate ? new Date(endDate).toISOString().split('T')[0] : ''}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col sm={12} lg={3} md={3}>
                                                        <Input
                                                        style={{height: "40px"}}
                                                            type="text"
                                                            placeholder="Search picture"
                                                            value={keyword}
                                                            onChange={handleSearchChange}
                                                            data-testing-id="searchImage_mediaCenter"

                                                        >
                                                        </Input>
                                                    </Col>
                                                    <Col sm={12} lg={2} md={2} className="d-flex ">
                                                        <button type="button" className="btn btn-outline-dark" data-testing-Id="clearButton_mediaCenter" onClick={handleClear}>Clear</button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ms-2"
                                                            data-testing-Id="searchButton_mediaCenter"
                                                            onClick={handleSearch}
                                                        >
                                                            Search
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {folderStack.length > 0 && (
                                            <MediaBreadCrumb folderStack={folderStack} handleBackClick={handleBackClick} isLoading={isLoading} />
                                        )}


                                        <div className="folderDv">

                                            <div className="d-flex justify-content-between align-items-center ">
                                                <h4>Folder(s)</h4>
                                                {/* <i className='bx bx-x fs-2 cursor-pointer' data-testing-Id="closeIconbackground_mediaCenter" style={{ color: "#CACACA" }} ></i> */}

                                            </div>
                                            <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3 mb-3">
                                                {isLoading ? (
                                                    <div className="loader">Loading...</div>
                                                ) : folder && folder.length > 0 ? (
                                                    folder.map((item: any, index: number) => (
                                                        <div
                                                            key={item._id}
                                                            className="imageBoxActive avatar-sm rounded-2 d-flex justify-content-start align-items-center flex-column gap-2 py-2"
                                                            data-testing-Id={'folder_mediacenter' + index}
                                                            style={{
                                                                cursor: 'pointer',
                                                                width: '140px',
                                                                height: '200px',
                                                                background: 'rgb(243 243 243)',
                                                            }}
                                                            onClick={() => handleFolderClick(item.folderName, item._id)}
                                                        >
                                                            <div className="d-flex justify-content-end fs-3 w-100 z-3">
                                                                <i
                                                                    id={`hoverPopover-${item._id}`}
                                                                    className="bx bx-dots-horizontal-rounded me-2"
                                                                    style={{ color: "#CACACA", cursor: "pointer" }}
                                                                    onMouseEnter={() => handleMouseEnter(item._id)} // Pass folder ID
                                                                    onMouseLeave={() => handleMouseLeave()}
                                                                    data-testing-Id={'threeDotIcon_mediacenter' + index}
                                                                ></i>

                                                                <Popover
                                                                
                                                                    placement="bottom"
                                                                    isOpen={activePopover === item._id} 
                                                                    target={`hoverPopover-${item._id}`}
                                                                    trigger="manual"
                                                                    aria-labelledby={`popover-${item._id}`}
                                                                    toggle={() => setPopoverOpen(false)} 
                                                                    
                                                                 >
                                                                  <PopoverBody
  onMouseEnter={() => handleMouseEnter(item._id)}
  onMouseLeave={handleMouseLeave}
  onClick={(e) => e.stopPropagation()} // 👈 Prevent accidental close
  className="px-0 py-3"
>
  <div className="d-flex flex-column gap-2">
    <div
      className="activeItemsPop w-100 px-2"
      data-testing-id="edit_mediacenter"
      onClick={(e) => {
        e.stopPropagation();
        handleEdit(item.folderName, item._id);
        setActivePopover(null); // ✅ Manually close popover if needed
      }}
    >
      <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">Edit</p>
    </div>
    <div
      className="activeItemsPop w-100 px-2"
      data-testing-id="delete_mediacenter"
      onClick={(e) => {
        e.stopPropagation();
        setFolderDeleteId(item._id);
        setDeleteFolderModal(true);
        setActivePopover(null); // ✅ Manually close popover if needed
      }}
    >
      <p className="text-decoration-none text-dark m-0 p-0 cursor-pointer">Delete</p>
    </div>
    <div
      className="activeItemsPop w-100 px-2"
      data-testing-id="exportURL_mediacenter"
      onClick={(e) => {
        e.stopPropagation();
        exportMediaURLs(item._id);
        setActivePopover(null); // ✅ Manually close popover if needed
      }}
    >
      <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">Export Url</p>
    </div>
  </div>
</PopoverBody>

                                                                </Popover>
                                                            </div>

                                                            <div style={{ width: '120px', height: '130px' }} className="mb-3"
                                                            >
                                                                <img
                                                                    src={floder} // Ensure 'floder' is correctly imported
                                                                    alt="Folder Image"
                                                                    className="img-fluid d-block w-100 h-100"
                                                                />
                                                            </div>
                                                            <p
                                                                className="m-0 text-center fs-6"
                                                                style={{
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                {item.folderName || 'Folder Name'}
                                                            </p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No folders available</p>
                                                )}
                                            </div>

                                        </div>



                                        <div className="cardBody">
                                        <div className="d-flex justify-content-between align-items-center ">
                                            <h4>Image(s)</h4>
                                            </div>
                                            <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3">
                                                {Array.isArray(media) && media.length > 0 ? (
                                                    media
                                                        .filter((item) => item.type === 'image')
                                                        .map((item, index: number) => {
                                                            const mediaUrl = item?.url || 'https://via.placeholder.com/120';
                                                            const mediaName = item?.metaData?.name || 'Untitled';
                                                            return (
                                                                <div
                                                                    key={item._id}
                                                                    data-testing-Id={'imageBoxs_mediacenter' + index}
                                                                    className={`imageBoxActive avatar-sm rounded-2 d-flex justify-content-start align-items-center flex-column gap-2 py-2 ${activeItems[item?._id] ? 'checked-box' : ''}`}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        width: '140px',
                                                                        height: '250px',
                                                                        backgroundColor: activeItems[item?._id] ? '#CACACA' : 'rgb(243 243 243)',
                                                                        border: activeItems[item?._id] ? '2px solid #0877FF' : 'none',
                                                                    }}
                                                                >
                                                                    <div className="d-flex justify-content-between align-items-center w-100 px-1">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="productCheckBox form-check-input"
                                                                            data-testing-id={'imageCheckbox_mediaCenter' + index}
                                                                            onChange={() => handleCheckboxChange(item._id)}
                                                                            checked={!!activeItems[item._id]}
                                                                        />
                                                                        <i
                                                                            id={`hoverPopover-${item._id}`}
                                                                            className="bx bx-dots-horizontal-rounded me-2"
                                                                            data-testing-Id={'threeDotIconImage_mediacenter' + index}
                                                                            style={{ color: "#CACACA", cursor: "pointer" }}
                                                                            onMouseEnter={() => handlePopoverToggle(item._id)}
                                                                            onMouseLeave={() => handlePopoverToggle(null)}
                                                                        ></i>

                                                                        <Popover
                                                                            placement="bottom"
                                                                            isOpen={activePopover === item._id}
                                                                            target={`hoverPopover-${item._id}`}
                                                                            trigger="manual"
                                                                            // toggle={() => setPopoverOpen(false)}

                                                                        >
                                                                            <PopoverBody
                                                                                onMouseEnter={() => handlePopoverToggle(item._id)} // Keep popover open
                                                                                onMouseLeave={() => handlePopoverToggle(null)} // Hide on mouse leave
                                                                                className="px-0 py-3"
                                                                            >
                                                                                <div className="d-flex flex-column gap-2">
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                        onClick={() => { handleEditClick(mediaUrl) }}
                                                                                        data-testing-Id='imageEdit_mediacenter'
                                                                                    >
                                                                                        <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                                                                            Edit
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                    >
                                                                                        <p
                                                                                            className="text-decoration-none text-dark m-0 p-0 cursor-pointer"
                                                                                            onClick={() => {
                                                                                                setSelectedItemId(item._id);
                                                                                                setDeleteModal(true);
                                                                                            }}
                                                                                            data-testing-Id='imageDelete_mediacenter'
                                                                                        >
                                                                                            Delete
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                        data-testing-Id='imageDownload_mediacenter'
                                                                                    >
                                                                                        <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer"
                                                                                            onClick={() => handleDownload(mediaUrl, mediaName)}
                                                                                        >
                                                                                            Download
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                        onClick={() => { handleImageClickDetail(item) }}
                                                                                        data-testing-Id='imageViewDetail_mediacenter'
                                                                                    >
                                                                                        <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                                                                            View Detail
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                    >
                                                                                        <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer"
                                                                                            onClick={handleExportToCSV}
                                                                                            data-testing-Id='imageExportURl_mediacenter'
                                                                                        >
                                                                                            Export Url
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="activeItemsPop w-100 px-2"
                                                                                    >
                                                                                        <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer"
                                                                                            onClick={() => handleCopyToClipboard(mediaUrl)}
                                                                                            data-testing-Id='imageCopyLink_mediacenter'
                                                                                        >
                                                                                            Copy Link
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </PopoverBody>
                                                                        </Popover>
                                                                    </div>

                                                                    <div style={{ width: '120px', height: '130px' }} className="mb-3">
                                                                        <img
                                                                            src={mediaUrl}
                                                                            alt={mediaName}
                                                                            className="img-fluid d-block w-100"
                                                                            style={{ height: 'auto', maxHeight: '130px', minHeight: '110px' }}
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className="cursor-pointer d-flex justify-content-center align-items-center bg-white rounded-circle ms-auto"
                                                                        style={{ width: '25px', height: '25px' }}
                                                                        data-testing-Id={'copyIcon_mediaCenter' + index}
                                                                        onClick={() => handleCopy(mediaUrl)}
                                                                    >
                                                                        <i className="bx bx-copy-alt"></i>
                                                                    </div>
                                                                    <p
                                                                        className="m-0 text-center fs-6"
                                                                        title={mediaName}
                                                                        style={{
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            width: '110px',
                                                                        }}
                                                                    >
                                                                        {mediaName}
                                                                    </p>
                                                                </div>
                                                            );
                                                        })
                                                ) : (
                                                    <p>No media items available.</p>
                                                )}
                                            </div>


                                            {isEditorOpen && selectedImage && (
                                                <div className="modal-overlay">
                                                    <div className="modal-contentDv">
                                                        <ImageEditorComponent
                                                            id="image-editor"
                                                            data-testing-Id="EidtImageModal_mediaCenter"
                                                            className="editImgRex"
                                                            ref={imageEditorRef}
                                                            height="400px"
                                                            width="600px"
                                                            // imageUrl={selectedImage as string}
                                                            toolbar={['Crop',
                                                                'Crop',
                                                                'ZoomIn',
                                                                'ZoomOut',
                                                                'Undo',
                                                                'Redo',
                                                                //  'Save',
                                                                'Delete',
                                                                'Reset',
                                                                'RotateLeft',
                                                                'RotateRight',
                                                                'FlipHorizontal',
                                                                'FlipVertical',
                                                                // 'Open',
                                                                'Selection',
                                                                'Annotation',
                                                                'FreehandDraw',
                                                                'Brightness',
                                                                'Contrast',
                                                                'Saturation',
                                                                'Blur',
                                                                'Sharpen',
                                                                'Pan',
                                                                'FillColor',
                                                                'StrokeColor'
                                                            ]}
                                                        // imageUrl={selectedImage as string}   
                                                        />
                                                        <div className="d-flex justify-content-end mt-3">
                                                            <button style={{background:'#0877FF'}} className="btn btn-secondary me-2" data-testing-Id="cancelButtonEidtImage_mediaCenter" onClick={() => setIsEditorOpen(false)}>
                                                                Cancel
                                                            </button>
                                                            <button style={{background:'#0877FF'}} className="btn btn-success" data-testing-Id="cancelButtonSave_mediaCenter" onClick={handleSave} disabled={loading}>
                                                                {loading ? (
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                ) : (
                                                                    "Save"
                                                                )}
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            {isAnyActive && (
                                                <Col sm="12" md="12" lg="12" className="mediaLine position-sticky bottom-0">
                                                    <div className="d-flex justify-content-between align-items-center my-3 shadow-lg p-3 rounded-3 position-sticky bottom-0 bg-white mediaLine" >
                                                        <p className="m-0 p-0">
                                                            Selected: {Object.values(activeItems).filter((isActive) => isActive).length} Image{Object.values(activeItems).filter((isActive) => isActive).length > 1 ? 's' : ''}
                                                        </p>
                                                        <div className="d-flex justify-content-end align-items-center gap-2 mediaLine">
                                                            <p className="text-secondary m-0 p-0 cursor-pointer" data-testing-Id="selectAll_mediaCenter" onClick={handleSelectAll}>Select all</p>
                                                            <button type="button" className="btn btn-outline-secondary" data-testing-Id="cancelButton_mediaCenter" onClick={clearSelected}>Cancel</button>
                                                            <button type="button" className="btn btn-outline-secondary" data-testing-Id="exportButton_mediaCenter" onClick={handleExportUrls}> Export URLS</button>
                                                            <button type="button" className="btn btn-outline-secondary" data-testing-Id="moveToButton_mediaCenter" onClick={() => setMoveToFolderModal(true)}>Move to</button>
                                                            <button type="button" className="btn btn-outline-secondary" data-testing-Id="removeBackgroundButton_mediaCenter" onClick={() => setRemovebackgroundModal(true)} disabled={isButtonDisabled} >Remove background</button>
                                                            <button className="btn btn-danger" type="submit" data-testing-Id="deleteButton_mediaCenter" onClick={() => setDeleteModal(true)}>Delete</button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                        </div>

                                    </TabPane>
                                    <TabPane id="steparrow-gen-info-tab" tabId={5}>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <div className="inputFeild">
                                                <Input
                                                    name="text"
                                                    className="form-control leftPad"
                                                    placeholder="Search Video"
                                                    data-testing-Id="videoSearch_mediaCenter"

                                                    value={keywordVideos}
                                                    onChange={(e) => setkeywordVideos(e.target.value)}
                                                />
                                                <i className="bx bx-search"></i>
                                            </div>
                                        </div>
                                        <div className="VideoRow d-flex justify-content-start align-items-center flex-wrap gap-3 mt-3">
                                            {Array.isArray(videos) && videos.length > 0 ? (
                                                videos
                                                    .filter((item) => item.type === 'video') // Filter only video items
                                                    .map((item, index: number) => {
                                                        const videoUrl = item?.url || 'https://via.placeholder.com/120';
                                                        const videoName = item?.metaData?.name || 'Untitled';
                                                        const updatedOnTimestamp = item?.createdOn || null;
                                                        const updatedOn = updatedOnTimestamp
                                                            ? new Date(updatedOnTimestamp).toLocaleString('en-US', {
                                                                year: 'numeric',
                                                                month: '2-digit',
                                                                day: '2-digit',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit',
                                                            })
                                                            : 'Unknown Date';

                                                        const rawDuration = item?.metaData?.duration || 0;
                                                        const durationMinutes = Math.floor(rawDuration / 60);
                                                        const durationSeconds = Math.floor(rawDuration % 60);
                                                        const duration = `${durationMinutes}:${durationSeconds < 10 ? '0' : ''}${durationSeconds}`;

                                                        const isSelected = selectedVideos.includes(item._id);



                                                        return (
                                                            <div
                                                                key={item._id}
                                                                className={`videoBox d-flex flex-column justify-content-between rounded-2 p-2 position-relative ${isSelected ? 'selected' : ''
                                                                    }`}
                                                                onClick={() => handleVideoSelect(item._id)}
                                                                data-testing-Id={'videoBox_mediaCenter' + index}
                                                                style={{
                                                                    border: isSelected ? '2px solid #007bff' : '1px solid #ddd',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <div className="videoDetails mt-2" >
                                                                    <p
                                                                        className="videoName text-truncate"
                                                                        title={videoName}
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            marginBottom: '5px',
                                                                        }}
                                                                    >
                                                                        {videoName}
                                                                    </p>
                                                                    <p
                                                                        className="updatedOn text-muted"
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            marginBottom: '0',
                                                                        }}
                                                                    >
                                                                        Updated On: {updatedOn}
                                                                    </p>
                                                                </div>
                                                                <div className="videoWrapper position-relative">
                                                                    <video
                                                                        width="100%"
                                                                        height="150px"
                                                                        data-testing-Id={'video_mediaCenter' + index}
                                                                        controls
                                                                        style={{ borderRadius: '8px' }}
                                                                        onClick={() => openViewer(item.url)}
                                                                    >
                                                                        <source src={videoUrl} type="video/mp4" />
                                                                        Your browser does not support the video tag.
                                                                    </video>
                                                                    <span
                                                                        className="durationBadge position-absolute"
                                                                        style={{
                                                                            top: '10px',
                                                                            right: '10px',
                                                                            backgroundColor: '#000',
                                                                            color: '#fff',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '3px',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {duration}
                                                                    </span>
                                                                </div>
                                                                {isSelected && (
                                                                    <i
                                                                        className="bx bx-check-circle position-absolute"
                                                                        style={{
                                                                            top: '5px',
                                                                            right: '5px',
                                                                            color: '#007bff',
                                                                            fontSize: '20px',
                                                                        }}
                                                                    ></i>
                                                                )}
                                                                <VideoViewer isOpen={isViewerOpen} videoUrl={currentImage} toggle={closeViewer} />
                                                            </div>

                                                        );
                                                    })
                                            ) : (
                                                <p>No videos available.</p>
                                            )}
                                        </div>

                                        {selectedVideos.length > 0 && (
                                            <div className="exportButton d-flex justify-content-end mt-3">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={exportToCSV}
                                                    style={{ backgroundColor: '#007bff', border: 'none', borderRadius: '5px' }}
                                                    data-testing-id="exportToCsv_mediaCenter"
                                                >
                                                    Export to CSV
                                                </button>
                                            </div>
                                        )}

                                    </TabPane>

                                </TabContent>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>

    );
};

export default MediaCenter;
